export default {
  FETCH_AVAILABILITIES: 'FETCH_AVAILABILITIES',
  CLEAR_AVAILABILITIES_BY_TYPE: 'CLEAR_AVAILABILITIES_BY_TYPE',
  SET_DETAILPAGE_TO_SPAREPARTS_DETAIL: 'SET_DETAILPAGE_TO_SPAREPARTS_DETAIL',
}
